

































import demo1 from './demo1.vue';
import Anchor from '@/packages/d-anchor';
import Vue from 'vue';
import Component from 'vue-class-component';
import DSlider from '@/packages/d-slider';
import title from '../../packages/d-slider/demo/README.md';

Vue.use(Anchor);
Vue.use(DSlider);
@Component({
  name: 'ComponentDemo',
  components: {
    demo1
  }
})
export default class ComponentDemo extends Vue {
  public title = title;

  public getContainer() {
    return document.getElementById('app-content');
  }
}
